import { Switch as CustomSwitch, SwitchProps } from '@mui/material';
import { FC } from 'react';

interface CustomSwitchProps extends SwitchProps {}

/**
 * Customizable switch component.
 *
 * @example
 * <Switch
 *   checked={Boolean(value)}
 *   onChange={(e) => setValue(e.target.checked)}
 * />
 *
 * @param {CustomSwitchProps} props - The props for the switch component.
 * @returns {JSX.Element} The rendered switch component.
 */
export const Switch: FC<CustomSwitchProps> = (props) => {
  return (
    <CustomSwitch
      {...props}
      sx={{
        '& .MuiSwitch-switchBase': {
          color: 'black',
          '&.Mui-checked': {
            color: 'black',
          },
          '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: 'gray',
          },
          '&:hover': {
            backgroundColor: 'transparent',
          },
          '&:active': {
            backgroundColor: 'transparent',
          },
        },
        '& .MuiSwitch-track': {
          backgroundColor: 'gray',
        },
      }}
    />
  );
};
